import { useState, useCallback } from "react";
import { InvoiceAnalysisService } from "../../../application/services/aiServices/invoiceAnalysisService";

const invoiceAnalysisService = new InvoiceAnalysisService();

export const useInvoiceAnalysis = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [invoiceAnalysis, setInvoiceAnalysis] = useState(null);

  const getLatestInvoiceAnalysis = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await invoiceAnalysisService.getLatestInvoiceAnalysis();
      if (result.success) {
        setInvoiceAnalysis(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  const analyzeInvoices = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await invoiceAnalysisService.analyzeInvoices();
      if (result.success) {
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getLatestInvoiceAnalysis,
    analyzeInvoices,
    invoiceAnalysis,
    loading,
    error,
  };
};